webpackJsonp([1,2],{

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
  bombCount: 50,
  row: 20,
  col: 20,
  maxRow: 100,
  maxCol: 100,
  theme: 'classic',
  cellClassName: {
    isFlag: 'flag fa-flag',
    status0: 'status0',
    isBomb: 'bomb fa-bomb',
    bombCount: 'bomb-count-',
    bombCount0: 'bomb-count-0'
  },
  cellDisplayText: {
    isFlag: '',
    status0: '',
    isBomb: '',
    bombCount: '',
    bombCount0: ''
  }
};

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);

var Utils = {};

if (!Array.prototype.fill) {
  Object.defineProperty(Array.prototype, 'fill', {
    value: function value(_value) {
      if (this == null) {
        throw new TypeError('this is null or not defined');
      }

      var O = Object(this);

      var len = O.length >>> 0;

      var start = arguments[1];
      var relativeStart = start >> 0;

      var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);

      var end = arguments[2];
      var relativeEnd = end === undefined ? len : end >> 0;

      var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);

      while (k < final) {
        O[k] = _value;
        k++;
      }

      return O;
    }
  });
}


Utils.randomBomb = function (bombCount, cellCount) {
  console.time('random');
  if (bombCount > cellCount) {
    bombCount = cellCount;
  }
  var cellArr = Array(cellCount).fill(false);
  var resultArr = Array(bombCount).fill(1).map(function uniqueRandom() {
    var randomIndex = ~~(Math.random() * cellCount);
    if (!cellArr[randomIndex]) {
      cellArr[randomIndex] = true;
      return randomIndex;
    } else {
      return uniqueRandom();
    }
  });
  var result = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
  resultArr.forEach(function (e) {
    return result.add(e);
  });
  console.timeEnd('random');
  return result;
};

Utils.getCellStatus = function (result, cell) {
  return cell.isFlag ? result.isFlag : cell.status === 0 ? result.status0 : cell.isBomb ? result.isBomb : cell.bombCount > 0 ? result.bombCount + cell.bombCount : result.bombCount0;
};

/* harmony default export */ __webpack_exports__["a"] = Utils;

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(49)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(44),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(46),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(51)
__webpack_require__(50)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(45),
  /* scopeId */
  "data-v-75f32dd9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 44:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('game')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.config.theme
  }, [_c('vue-drr', {
    staticClass: "scoreboard",
    attrs: {
      "w": 180,
      "h": 180,
      "r": 0,
      "resizeable": false,
      "rotatable": false
    }
  }, [_c('h3', [_vm._v("计分板")]), _vm._v("\n    旗帜数量： " + _vm._s(_vm.flagCount) + " "), _c('br'), _c('br'), _vm._v("\n    分数： " + _vm._s(_vm.score) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "game-config"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.init($event)
      }
    }
  }, [_c('label', [_vm._v("行: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputRow),
      expression: "inputRow"
    }],
    attrs: {
      "type": "number",
      "min": "2",
      "max": _vm.config.maxRow
    },
    domProps: {
      "value": (_vm.inputRow)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputRow = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("列: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputCol),
      expression: "inputCol"
    }],
    attrs: {
      "type": "number",
      "min": "2",
      "max": _vm.config.maxCol
    },
    domProps: {
      "value": (_vm.inputCol)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputCol = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('label', [_vm._v("雷的数量: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputBombCount),
      expression: "inputBombCount"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": ~~_vm.inputRow * ~~_vm.inputCol - 1
    },
    domProps: {
      "value": (_vm.inputBombCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputBombCount = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("生成")])]), _vm._v(" "), (_vm.showTips) ? _c('div', {
    staticClass: "game-config-tips"
  }, [_vm._v(_vm._s(_vm.tipsText))]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "game",
    class: {
      'tips-open': _vm.showTips
    },
    attrs: {
      "width": _vm.width
    },
    on: {
      "click": _vm.handleClick,
      "contextmenu": function($event) {
        $event.preventDefault();
        _vm.handleRightClick($event)
      },
      "dblclick": _vm.handleDblClick
    }
  }, _vm._l((_vm.cellData), function(rows, row) {
    return _c('tr', {
      key: row
    }, _vm._l((rows), function(cell, col) {
      return _c('cell', {
        key: col,
        attrs: {
          "row": cell.row,
          "col": cell.col,
          "isBomb": cell.isBomb,
          "status": cell.status,
          "isFlag": cell.isFlag,
          "bombCount": cell.bombCount
        }
      })
    }))
  })), _vm._v(" "), (_vm.gameOver) ? _c('div', {
    staticClass: "gameover layer"
  }, [_c('div', [_vm._v("Game Over")]), _vm._v(" "), _c('div', [_vm._v("你美丽了!")]), _vm._v(" "), _c('div', {
    staticClass: "retry"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.init($event)
      }
    }
  }, [_vm._v("再试一次")])]), _vm._v(" "), _c('div', {
    staticClass: "retry"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.view($event)
      }
    }
  }, [_vm._v("查看雷的位置")])])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "success layer"
  }, [_c('div', [_vm._v("Win!")]), _vm._v(" "), _c('div', [_vm._v("你成功了!")]), _vm._v(" "), _c('div', {
    staticClass: "retry"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.init($event)
      }
    }
  }, [_vm._v("我还要玩")])])]) : _vm._e(), _vm._v(" "), (_vm.viewBomb) ? _c('div', {
    staticClass: "layer-transparent"
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 46:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    class: _vm.className
  }, [_vm._v(_vm._s(_vm.display))])
},staticRenderFns: []}

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_game__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_game__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: {
    game: __WEBPACK_IMPORTED_MODULE_0__components_game___default.a
  }
};

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(38);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'cell',
  props: ['row', 'col', 'isBomb', 'status', 'isFlag', 'bombCount'],
  computed: {
    display: function display() {
      return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getCellStatus(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].cellDisplayText, this);
    },
    className: function className() {
      return __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].getCellStatus(__WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */].cellClassName, this);
    }
  }
};

/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cell__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_drag_resize_rotate__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_drag_resize_rotate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_drag_resize_rotate__);









var createRightClickEvent = function () {
  return 'ActiveXObject' in window ? function () {
    var evt = document.createEvent('MouseEvent');
    evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    return evt;
  } : function () {
    var evt = new MouseEvent('click', {
      button: 0,
      bubbles: true
    });
    return evt;
  };
}();

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'game',
  components: {
    cell: __WEBPACK_IMPORTED_MODULE_2__cell___default.a,
    'vue-drr': __WEBPACK_IMPORTED_MODULE_5_vue_drag_resize_rotate___default.a
  },
  data: function data() {
    return {
      config: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */]),
      gameOver: false,
      cellData: [],
      showTips: false,
      viewBomb: false,
      width: 0,
      flagCount: 0,
      score: 0,
      inputRow: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].row,
      inputCol: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].col,
      inputBombCount: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].bombCount,
      bombSet: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(),
      success: false,
      tipsText: ''
    };
  },
  mounted: function mounted() {
    this.init();
  },

  computed: {
    cellCount: function cellCount() {
      return this.config.col * this.config.row;
    }
  },
  watch: {
    score: function score(val) {
      if (val === this.cellCount - this.config.bombCount) {
        var $this = this;
        this.bombSet.forEach(function (e) {
          var col = e % $this.config.col;
          var row = ~~(e / $this.config.col);
          $this.cellData[row][col].isFlag = 1;
        });
        this.$forceUpdate();
        this.score = this.cellCount;
        this.flagCount = this.config.bombCount;
        this.success = true;
      }
    }
  },
  methods: {
    view: function view() {
      this.gameOver = false;
      this.viewBomb = true;
      var $this = this;
      this.bombSet.forEach(function (e) {
        var col = e % $this.config.col;
        var row = ~~(e / $this.config.col);
        $this.cellData[row][col].status = 1;
      });
      this.$forceUpdate();
    },
    init: function init() {
      if (~~this.inputCol > this.config.maxCol || ~~this.inputRow > this.config.maxRow) {
        this.tipsText = '请勿作死设置过大行列！';
        this.showTips = true;
        this.inputRow = this.config.row;
        this.inputCol = this.config.col;
        this.inputBombCount = this.config.bombCount;
        return;
      }
      this.config.col = ~~this.inputCol;
      this.config.row = ~~this.inputRow;
      if (~~this.inputBombCount >= this.cellCount) {
        this.tipsText = '雷的数量最大为格子数量减1';
        this.showTips = true;
        this.inputBombCount = this.cellCount - 1;
        return;
      }
      this.config.bombCount = ~~this.inputBombCount;
      this.showTips = false;
      this.success = false;
      this.gameOver = false;
      this.viewBomb = false;
      this.score = 0;
      this.flagCount = 0;
      this.width = this.config.col * 41 + 1;
      this.cellData = this.initData();
    },
    initData: function initData() {
      var _this = this;

      this.bombSet = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].randomBomb(this.config.bombCount, this.config.col * this.config.row);
      var result = [];
      console.time('map');
      result = Array(this.config.row).fill(0).map(function (e, row) {
        return Array(_this.config.col).fill(0).map(function (e, col) {
          return {
            status: 0,
            isFlag: false,
            row: row,
            col: col,
            isBomb: _this.bombSet.has(row * _this.config.col + col),
            bombCount: 0,
            isTriggered: false
          };
        });
      });
      console.timeEnd('map');
      return result;
    },
    fail: function fail() {
      this.gameOver = true;
    },
    handleClick: function handleClick(ev) {
      if (ev.target.nodeName !== 'TD') return;
      var col = ev.target.cellIndex;
      var row = ev.target.parentNode.rowIndex;
      var cell = this.cellData[row][col];
      if (cell.status !== 0) return;
      var clickType = ev.button;
      if (clickType === 0) {
        if (!cell.isFlag) {
          cell.status = 1;
          if (cell.isBomb) {
            this.$forceUpdate();
            this.fail();
            return;
          }
          this.score++;
          var aroundCell = this.getAroundCell(row, col);
          cell.bombCount = aroundCell.reduce(function (sum, cell) {
            return sum + (cell.isBomb ? 1 : 0);
          }, 0);
          if (cell.bombCount === 0) {
            var table = this.$el.querySelector('table');
            var nextTick = this.$nextTick;
            cell.isTriggered = true;
            aroundCell.forEach(function (e) {
              if (e.isTriggered || e.isFlag || e.status === 1) return;

              var evt = createRightClickEvent();
              nextTick(function () {
                table.rows[e.row].cells[e.col].dispatchEvent(evt);
              });
            });
          }
          this.$forceUpdate();
        }
      } else if (clickType === 2) {}
    },
    handleRightClick: function handleRightClick(ev) {
      if (ev.target.nodeName !== 'TD') return;
      var col = ev.target.cellIndex;
      var row = ev.target.parentNode.rowIndex;
      var cell = this.cellData[row][col];
      if (cell.status === 1) return;
      if (!cell.isFlag) {
        this.flagCount++;
        cell.isFlag = true;
      } else {
        this.flagCount--;
        cell.isFlag = false;
      }
      this.$forceUpdate();
    },
    handleDblClick: function handleDblClick(ev) {
      if (ev.target.nodeName !== 'TD') return;
      var col = ev.target.cellIndex;
      var row = ev.target.parentNode.rowIndex;
      var cell = this.cellData[row][col];
      if (cell.status !== 1) return;
      var table = this.$el.querySelector('table');
      var aroundCell = this.getAroundCell(row, col);
      var nextTick = this.$nextTick;
      cell.isTriggered = true;
      aroundCell.forEach(function (e) {
        if (e.isTriggered || e.isFlag || e.status === 1) return;

        var evt = createRightClickEvent();
        nextTick(function () {
          table.rows[e.row].cells[e.col].dispatchEvent(evt);
        });
      });
    },
    getAroundCell: function getAroundCell(row, col) {
      var rowArr = [row - 1, row, row + 1];
      var colArr = [col - 1, col, col + 1];
      var resultArr = [];
      var $vm = this;
      rowArr.forEach(function (r) {
        colArr.forEach(function (c) {
          if (r === row && c === col || r < 0 || r >= $vm.config.row || c < 0 || c >= $vm.config.col) return;
          resultArr.push($vm.cellData[r][c]);
        });
      });
      return resultArr;
    }
  }
};

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ })

},[95]);


// WEBPACK FOOTER //
// static/js/app.8505b68deb3a889bdcd1.js